var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('users-table',{attrs:{"users":_vm.users,"simplify":"","title-bar":""}},[_c('create-user')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }